<gp-modal #editor gp-modal="document-signature-fields" size="xl" [closable]="!saving">
  <div class="gp-modal-title">
    {{ (document?.signatureData?.signatureInfos?.length ? 'DOCUMENTS.edit_signature_fields' : 'DOCUMENTS.define_signature_fields') | translate }}
  </div>
  <div class="gp-modal-body signature-editor" *ngIf="visible">
    <div #signaturePlacementPreview *ngIf="placingRole && !loading && !loadFailed && !saving && !blocked"
         class="signature-field signature-placement-preview" [ngClass]="roleColor(placingRole)" aria-hidden="true">
      <em class="fa fa-light fa-signature" aria-hidden="true"></em>
      <span>{{ placingRole }}</span>
    </div>
    <aside class="signature-roles">
      <section class="signature-panel-section">
        <h4 class="signature-section-title">1. {{ 'TEMPLATE.add_signer_roles' | translate }}</h4>
        <div class="signer-role-add">
          <input [formControl]="roleControl" (keydown.enter)="addRole()" [readonly]="saving || blocked"
                 [attr.aria-label]="'TEMPLATE.signer_role' | translate" class="form-control"
                 [placeholder]="'TEMPLATE.signer_role_examples' | translate" test-id="signatureRoleInput">
          <button type="button" class="btn btn-primary btn-sm" (click)="addRole()"
                  [disabled]="!canAddRole || saving || blocked" [title]="'TEMPLATE.add_signer_role' | translate"
                  [attr.aria-label]="'TEMPLATE.add_signer_role' | translate" test-id="addSignatureRole">
            <em class="fa fa-light fa-plus m-r-xs" aria-hidden="true"></em>
            {{ 'TEMPLATE.add_signer_role' | translate }}
          </button>
        </div>
      </section>
      <section class="signature-panel-section">
        <h4 class="signature-section-title">2. {{ 'TEMPLATE.signer_roles' | translate }}</h4>
        <div *ngIf="!roles.length" class="signature-role-empty-state"><strong>{{ 'TEMPLATE.no_signer_roles' | translate }}</strong></div>
        <ul *ngIf="roles.length" class="signature-role-list">
          <li *ngFor="let role of roles" class="signature-role-item" [ngClass]="roleColor(role)"
              [class.signature-role-item--delete-confirmation]="pendingDeletionRole === role">
            <ng-container *ngIf="pendingDeletionRole !== role; else confirmDelete">
              <div class="signature-role-summary">
                <span class="text-ellipsis signature-role-name" [title]="role">{{ role }}</span>
                <span class="signature-role-count">{{ countForRole(role) | gpNumber: 'INTEGER' }} {{ (countForRole(role) === 1 ? 'TEMPLATE.signature_field' : 'TEMPLATE.signature_fields') | translate }}</span>
              </div>
              <button type="button" class="btn btn-sm btn-outline b-primary text-primary signature-role-action" (click)="placingRole = placingRole === role ? null : role"
                      [class.active]="placingRole === role" [attr.aria-pressed]="placingRole === role"
                      [disabled]="loading || loadFailed || saving || blocked" test-id="placeSignature">
                <em class="fa fa-light fa-signature m-r-xs" aria-hidden="true"></em>
                {{ 'TEMPLATE.add_signature' | translate }}
              </button>
              <button type="button" class="btn btn-sm btn-icon white signature-role-action text-danger" (click)="pendingDeletionRole = role"
                      [disabled]="saving || blocked" [title]="'TEMPLATE.delete_signer_role' | translate"
                      [attr.aria-label]="'TEMPLATE.delete_signer_role' | translate" test-id="deleteSignatureRole">
                <em class="fa fa-light fa-trash" aria-hidden="true"></em>
              </button>
            </ng-container>
            <ng-template #confirmDelete>
              <div class="signature-role-delete-message">
                <em class="fa fa-light fa-triangle-exclamation text-danger" aria-hidden="true"></em>
                <span>{{ 'TEMPLATE.confirm_delete_signer_role_inline' | translate: {signerRole: role} }}</span>
              </div>
              <div class="signature-role-delete-actions">
                <button type="button" class="btn btn-outline btn-sm" (click)="pendingDeletionRole = null" [disabled]="saving">{{ 'FORMS.cancel' | translate }}</button>
                <button type="button" class="btn btn-danger btn-sm" (click)="deleteRole(role)" [disabled]="saving || blocked" test-id="confirmDeleteSignatureRole">{{ 'COMMON.delete' | translate }}</button>
              </div>
            </ng-template>
          </li>
        </ul>
      </section>
      <div *ngIf="blocked" class="text-danger" role="alert">{{ 'DOCUMENTS.signature_fields_unavailable' | translate }}</div>
    </aside>
    <section class="signature-preview">
      <div class="pdf-toolbar">
        <span class="document-name" [title]="document.name">{{ document.name }}</span>
        <button type="button" class="btn btn-icon btn-sm" (click)="changePage(pageNumber - 1)"
                [disabled]="pageNumber <= 1 || loading || loadFailed || saving" [title]="'FORMS.previous_page' | translate"
                [attr.aria-label]="'FORMS.previous_page' | translate">
          <em class="fa fa-light fa-chevron-left" aria-hidden="true"></em>
        </button>
        <span class="page-count">{{ pageNumber | gpNumber: 'INTEGER' }} / {{ pageCount | gpNumber: 'INTEGER' }}</span>
        <button type="button" class="btn btn-icon btn-sm" (click)="changePage(pageNumber + 1)"
                [disabled]="pageNumber >= pageCount || loading || loadFailed || saving" [title]="'FORMS.next' | translate"
                [attr.aria-label]="'FORMS.next' | translate">
          <em class="fa fa-light fa-chevron-right" aria-hidden="true"></em>
        </button>
        <button type="button" class="btn btn-icon btn-sm" (click)="changeZoom(-0.2)" [disabled]="zoom <= 0.4 || loading || loadFailed || saving"
                [title]="'TOOLTIPS.zoom_out' | translate" [attr.aria-label]="'TOOLTIPS.zoom_out' | translate">
          <em class="fa fa-light fa-magnifying-glass-minus" aria-hidden="true"></em>
        </button>
        <span class="zoom-level">{{ zoom * 100 | gpNumber: 'INTEGER' }}%</span>
        <button type="button" class="btn btn-icon btn-sm" (click)="changeZoom(0.2)" [disabled]="zoom >= 1.6 || loading || loadFailed || saving"
                [title]="'TOOLTIPS.zoom_in' | translate" [attr.aria-label]="'TOOLTIPS.zoom_in' | translate">
          <em class="fa fa-light fa-magnifying-glass-plus" aria-hidden="true"></em>
        </button>
      </div>
      <div class="pdf-scroll" [attr.aria-busy]="loading">
        <span *ngIf="loading" class="gp-spinner gp-spinner--primary pdf-loading" role="status" [attr.aria-label]="'DOCUMENTS.loading_pdf' | translate"></span>
        <div *ngIf="loadFailed" class="pdf-error" role="alert">
          <gp-illustrated-message [type]="'SOMETHING_WRONG'" [text]="'DOCUMENTS.signature_preview_failed'"></gp-illustrated-message>
          <button type="button" class="btn btn-outline" (click)="loadDocument()">{{ 'TREE_OVERVIEW.retry' | translate }}</button>
        </div>
        <div *ngIf="source && !loadFailed" class="pdf-sheet" [style.width.px]="viewport?.width || 640" [style.height.px]="viewport?.height || 900">
          <pdf-viewer [src]="source" [page]="pageNumber" [show-all]="false" [original-size]="true"
                      [render-text]="false" [show-borders]="false" [zoom]="zoom" [autoresize]="false"
                      (after-load-complete)="onPdfLoaded($event)" (page-rendered)="onPageRendered($event)" (error)="onPdfError()">
          </pdf-viewer>
          <div *ngIf="viewport && !loading" class="signature-overlay" [class.placing]="placingRole" (pointerdown)="placeField($event)">
            <div *ngFor="let field of pageFields" class="signature-field" [ngClass]="roleColor(field.role)"
                 [class.selected]="selectedFieldId === field.id" [attr.aria-label]="field.role" role="button" tabindex="0"
                 [style.left.px]="fieldBounds(field).left" [style.top.px]="fieldBounds(field).top"
                 [style.width.px]="fieldBounds(field).width" [style.height.px]="fieldBounds(field).height"
                 [style.font-size.px]="fieldFontSize(field)"
                 (pointerdown)="startDrag($event, field)" (pointermove)="moveField($event, field)"
                 (pointerup)="stopDrag()" (pointercancel)="stopDrag()" (lostpointercapture)="stopDrag()"
                 (focus)="selectedFieldId = field.id" (keydown)="moveWithKeyboard($event, field)" test-id="signaturePlaceholder">
              <em class="fa fa-light fa-signature" aria-hidden="true"></em>
              <span>{{ field.role }}</span>
              <button type="button" class="btn btn-icon text-danger signature-field-delete" (pointerdown)="$event.stopPropagation()"
                      (click)="$event.stopPropagation(); deleteField(field)" [disabled]="saving || blocked"
                      [title]="'DOCUMENTS.delete_signature_field' | translate" [attr.aria-label]="'DOCUMENTS.delete_signature_field' | translate">
                <em class="fa fa-light fa-times" aria-hidden="true"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div class="gp-modal-footer signature-editor-footer">
    <button type="button" class="btn btn-outline-primary" (click)="editor.close()" [disabled]="saving">{{ 'FORMS.cancel' | translate }}</button>
    <div class="editor-save-actions">
      <button type="button" class="btn btn-outline-primary" (click)="save()" [disabled]="!canSave" test-id="saveSignatureFields">
        <em class="fa fa-light fa-floppy-disk" aria-hidden="true"></em> {{ 'FORMS.save' | translate }}
      </button>
      <button type="button" class="btn btn-fill-primary" (click)="save(true)" [disabled]="!canSave || !fields.length" test-id="saveAndSendSignatureFields">
        <em [class]="saving ? 'fa fa-light fa-spinner fa-spin' : 'fa fa-light fa-paper-plane'" aria-hidden="true"></em>
        {{ 'DOCUMENTS.send_for_signature' | translate }}
      </button>
    </div>
  </div>
</gp-modal>